import { Grid, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';

import { useSnackbar } from 'notistack';

import MuiDialog from 'components/MuiDialog';
import {
  SurveyDialogProps,
  TTakingOverDefaultValues,
} from 'routes/Main/Survey/type';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';

import CommonPatientInfo from '../components/CommonPatientInfo';
import TextareaSection from '../components/TextAreaSection';

import { updateTakingOver } from 'apis/survey';

const TakingOver = (props: SurveyDialogProps<TTakingOverDefaultValues>) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;

  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const { handleSubmit, register, getValues, setValue, watch } = useForm({
    defaultValues,
  });

  const { enqueueSnackbar } = useSnackbar();

  const onSubmit = (data: TTakingOverDefaultValues) => {
    const {
      loc,
      vital_sign,
      current_condition,
      rbfi,
      reasons,
      intervention,
      other,
    } = data;

    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      take_over_survey: { ...data },
    };

    updateTakingOver(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) return onResultCode(rc);

        onUpdateIsSave(true);
        onSuccess('Амжилттай хадгалагдлаа');
      })
      .catch(e => onFail('Хадгалж чадсангүй', e));
  };

  const formProps = {
    disabled,
    watch,
    register,
    getValues,
    setValue,
    onSuccess,
    onRequired,
  };

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
          }}
        >
          Сувилагч шилжүүлэх
        </Typography>
        <CommonPatientInfo patientInfo={patientInfo} nurseName={nurseName} />
        <TextareaSection
          {...formProps}
          title="Ухаан санааны түвшин (LOC)"
          registerId="loc"
        />
        <TextareaSection
          {...formProps}
          title="Амин үзүүлэлт (тодорхой)"
          registerId="vital_sign"
        />
        <TextareaSection
          {...formProps}
          title="Одоогийн байдал (Мэс заслын дараах өдөр, эмчилгээ, өвдөлтийн үнэлгээ, катетер, эм, эмчилгээний хоол гэх мэт)"
          registerId="current_condition"
        />
        <TextareaSection
          {...formProps}
          title="Хязгаарлалт / Даралтат шарх / Унах эрсдэл / Тусгаарлалт"
          registerId="rbfi"
        />
        <TextareaSection
          {...formProps}
          title="Эмнэлэгт хэвтэх шалтгаан / Өвчний түүх / Хамшийн өвчин / Харшил"
          registerId="reasons"
        />
        <TextareaSection
          {...formProps}
          title="Сувилахуйн оролцоо (Шалгалт, эмчилгээ, бусад тасагт хүсэлт гэх мэт)"
          registerId="intervention"
        />
        <TextareaSection
          {...formProps}
          title="Бусад чухал тэмдэглэл"
          registerId="other"
        />
      </Grid>
    </MuiDialog.SurveyForm>
  );
};

export default TakingOver;
